module.exports = __webpack_public_path__ + "static/media/balance_10000_25000.f9f66715.png";